import { render, staticRenderFns } from "./EventTypeDetail.vue?vue&type=template&id=2b316fd3&scoped=true"
import script from "./EventTypeDetail.vue?vue&type=script&lang=js"
export * from "./EventTypeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b316fd3",
  null
  
)

export default component.exports